import { router } from 'expo-router';

import { FeatureCard, RoleHome } from '@/components/role-home';
import { supabase } from '@/lib/supabase';

export default function StudentHomeScreen() {
  return (
    <RoleHome
      accent="#1F5A37"
      description="Practice questions, take assigned exams, and track your own progress inside your class workspace."
      onSignOut={() => {
        void supabase.auth.signOut();
        router.replace('/sign-in');
      }}
      roleLabel="Student"
      title="Student practice area">
      <FeatureCard
        title="Assigned exams"
        body="Open the tests available to your class and submit answers within the allowed time."
      />
      <FeatureCard
        title="Practice mode"
        body="Work through published question sets and get quick feedback on your responses."
      />
      <FeatureCard
        title="Performance view"
        body="Review your own attempt history, scores, and question-level accuracy over time."
      />
    </RoleHome>
  );
}
